import EmployeeDetails, { Profile } from "@containers/HRM/EmployeeDetails";
import EmployeeList from "@containers/HRM/EmployeeList";
import PermanentList from "@containers/HRM/PermanentList";
import SeniorityList from "@containers/HRM/SeniorityList";

import ModifyPosition from "@containers/HRM/ModifyPosition";
import PositionList from "@containers/HRM/PositionList";

import CreateRetirement from "@containers/HRM/CreateRetirement";
import RetirementDetails from "@containers/HRM/RetirementDetails";
import RetirementList from "@containers/HRM/RetirementList";

import CreateResignation from "@containers/HRM/CreateResignation";
import ResignationDetails from "@containers/HRM/ResignationDetails";
import ResignationList from "@containers/HRM/ResignationList";

import Acr from "@containers/HRM/Acr";
import Apr from "@containers/HRM/Apr";

import PunishmentHistoryList from "@containers/HRM/PunishmentHistoryList";

import CentralAttendanceList from "@containers/HRM/CentralAttendanceList";
import CreateEmployee from "@containers/HRM/CreateEmployee";

import TransferCandidates from "@containers/HRM/TransferCandidates";
import Transfers from "@containers/HRM/Transfers";

import InitiatePromotion from "@containers/HRM/InitiatePromotion";
import PromotionCandidates from "@containers/HRM/PromotionCandidates";
import PromotionList from "@containers/HRM/PromotionList";

import Notifications from "@containers/HRM/notifications";
import OrgChart from "@containers/HRM/OrgChart";

import CreateNewLoan from "@containers/HRM/CreateNewLoan";
import GpfList from "@containers/HRM/GpfList";
import InstallmentDetails from "@containers/HRM/InstallmentDetails";

import LeaveApply from "@containers/HRM/LeaveApply";
import LeaveDetails from "@containers/HRM/LeaveDetails";
import EmployeeLeaveTable from "@containers/HRM/LeaveManagementList";
import LeaveSettings from "@containers/HRM/LeaveSettings";
import TransferDetails from "@containers/HRM/TransferDetails";
import UpdateLeaveBalance from "@containers/HRM/UpdateLeaveBalance";

import DeputationList from "@containers/HRM/DeputationList";
// import DossierList from "@containers/HRM/Dossier";
import JobReports from "@containers/HRM/JobReports";
import ManpowerDetailsReports from "@containers/HRM/ManpowerDetailsReports";
import ManpowerRecruitReports from "@containers/HRM/ManpowerRecruitReports";
import ManpowerReports from "@containers/HRM/ManpowerReports";
import ManpowerSummaryReports from "@containers/HRM/ManpowerSummaryReports";
import PrlReports from "@containers/HRM/PrlReports";
import PromotionReports from "@containers/HRM/PromotionReports";
import ReleaseDetails from "@containers/HRM/ReleaseDetails";
import ReleaseList from "@containers/HRM/ReleaseList";
import RewardReports from "@containers/HRM/RewardReports";
import HRMSettings from "@containers/HRM/Settings";

import NoMatch from "@containers/no-match";

import { ROUTES } from "@constants/routes";
import { RouteType } from "./types";
import DossierEmployeeList from "@containers/HRM/DossierEmployeeList";
import DossierEmployeeDetails from "@containers/HRM/DossierEmployeeDetails";
import PensionReports from "@containers/HRM/pensionReports";
import ResignationReports from "@containers/HRM/resignationReports";
import RetirementReports from "@containers/HRM/RetirementReports";
import ReleaseReports from "@containers/HRM/ReleaseReports";
import YearlyReportsPage from "@containers/HRM/yearlyReports";
import AcrReports from "@containers/HRM/AcrReports";
import DeceasedList from "@containers/HRM/DeceasedList";
import DeceasedDetails from "@containers/HRM/DeceasedDetails";
import DeceasedsList from "@containers/HRM/Deceaseds";
import TerminationList from "@containers/HRM/TerminationList";
import TerminationDetails from "@containers/HRM/TerminationDetails";
import Terminations from "@containers/HRM/Terminations";
import ExtraPositionInformations from "@containers/HRM/extraPositionInformations";
import InterChangeTransfers from "@containers/HRM/InterchangeTransfers";
import InterchangeTransferDetails from "@containers/HRM/InterchangeTransferDetails";
import PositionListTree from "@containers/HRM/PositionListTree";
import FileInquiryList from "@containers/HRM/FileInquiryList";
import FileInquiry from "@containers/HRM/FileInquiry";

const {
  CREATE,
  UPDATE,
  ID,
  ID_2,
  SETTINGS,
  HRM: {
    EMPLOYEES,
    ORG_CHART,
    SENIORITY,
    PERMANENT,
    DEPUTATION,
    RELEASE,
    TRANSFER_CANDIDATES,
    TRANSFERS,
    PROMOTION_CANDIDATES,
    PROMOTION,
    RESIGNATION,
    NOTIFICATIONS,
    RETIREMENTS,
    CENTRAL_ATTENDANCE,
    ACR,
    APR,
    DOSSIER,
    POSITIONS,
    POSITION_TREE,
    PROVIDENT_FUND,
    PUNISHMENT,
    LEAVE,
    SETTINGS: HRM_SETTINGS,
    PROFILE,
    MANPOWER_REPORTS,
    PROMOTION_REPORTS,
    PRL_REPORTS,
    REWARD_REPORTS,
    JOB_REPORTS,
    MANPOWER_SUMMARY_REPORTS,
    MANPOWER_DETAILS_REPORTS,
    MANPOWER_RECRUIT_REPORTS,
    PENSION_REPORTS,
    RELEASE_REPORTS,
    RESIGNATION_REPORTS,
    RETIREMENT_REPORTS,
    YEARLY_REPORTS,
    ACR_REPORTS,
    DECEASED_LIST,
    DECEASED,
    TERMINATION,
    TERMINATION_LIST,
    EXTRA_POSITION_INFORMATIONS,
    INTERCHANGE_TRANSFERS,
    FILE_INQUIRY,
  },
} = ROUTES;

export const HRMRoutes: RouteType[] = [
  //EMPLOYEE MODULE
  {
    id: "employee_module",
    path: EMPLOYEES,
    children: [
      //EMPLOYEE TABLE
      {
        id: "employee_list",
        index: true,
        element: <EmployeeList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "EMPLOYEE_VIEW_PAGE",
        },
      },

      // CREATE EMPLOYEE
      {
        id: "employee_create",
        path: CREATE,
        element: <CreateEmployee />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "EMPLOYEE_CREATE_PAGE",
        },
      },

      //EMPLOYEE DETAIL
      {
        id: "employee_details",
        path: ID,
        element: <EmployeeDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "EMPLOYEE_UPDATE_PAGE",
        },
      },
    ],
  },

  //ORG CHART
  {
    id: "org_chart",
    path: ORG_CHART,
    element: <OrgChart />,
    redirection: <NoMatch />,
    permissions: {
      auth: ["token"],
      access: "CAN_VIEW_ORG_CHART",
    },
  },

  //Extra Position Information
  {
    id: "extra_position_informations",
    path: EXTRA_POSITION_INFORMATIONS,
    element: <ExtraPositionInformations />,
    redirection: <NoMatch />,
    permissions: {
      auth: ["token"],
      access: "POSITION_VIEW_PAGE",
    },
  },

  //POSITION TREE
  {
    id: "position_tree",
    path: POSITION_TREE,
    element: <PositionListTree />,
    redirection: <NoMatch />,
    permissions: {
      auth: ["token"],
      access: "EMPLOYEE_POSITION_LIST_PAGE",
    },
  },

  //POSITION MODULE
  {
    id: "position_module",
    path: POSITIONS,
    children: [
      //   POSTIONS TABLE
      {
        id: "postions_list",
        index: true,
        element: <PositionList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "POSITION_VIEW_PAGE",
        },
      },

      //POSITION CREATE
      {
        id: "position_create",
        path: CREATE,
        element: <ModifyPosition />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "POSITION_MODIFY_PAGE",
        },
      },

      //POSITION UPDATE
      {
        id: "position_update",
        path: ID,
        element: <ModifyPosition />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "POSITION_MODIFY_PAGE",
        },
      },
    ],
  },

  //SENIORITY MODULE
  {
    id: "seniority_module",
    path: SENIORITY,
    children: [
      //SENIORITY TABLE
      {
        id: "seniority_list",
        index: true,
        element: <SeniorityList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "SENIORITY_LIST_PAGE",
        },
      },
    ],
  },

  //PERMANENT MODULE
  {
    id: "permanent_module",
    path: PERMANENT,
    children: [
      // PERMANENT TABLE
      {
        id: "parmanent_list",
        index: true,
        element: <PermanentList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "PERMANENT_LIST_PAGE",
        },
      },
    ],
  },

  {
    id: "deputation_module",
    path: DEPUTATION,
    children: [
      // DEPUTATION TABLE
      {
        id: "deputation_list",
        index: true,
        element: <DeputationList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "RELEASE_UPDATE",
        },
      },
    ],
  },

  // TRANSFER CANDIDATE MODULE
  {
    id: "transfer_candidate_module",
    path: TRANSFER_CANDIDATES,
    children: [
      {
        id: "tansfer_candidate",
        index: true,
        element: <TransferCandidates />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "TRANSFER_INITIATE",
        },
      },
    ],
  },

  // DECEASED LIST
  {
    id: "deceased_list",
    path: DECEASED_LIST,
    element: <DeceasedList />,
    redirection: <NoMatch />,
    permissions: {
      auth: ["token"],
    },
  },

  //DECEASED MODULE
  {
    id: "deceased_module",
    path: DECEASED,
    children: [
      //DECEASED TABLE
      {
        id: "deceased",
        index: true,
        element: <DeceasedsList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },

      //DECEASED DETAILS
      {
        id: "deceased_details",
        path: ID,
        element: <DeceasedDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },

      //DECEASED CREATE
      {
        id: "deceased_create",
        path: `${ID}/${CREATE}`,
        element: <DeceasedDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },
    ],
  },

  //FILE INQUIRY MODULE
  {
    id: "file_inquiry_module",
    path: FILE_INQUIRY,
    children: [
      //FILE TABLE
      {
        id: "file_inquiry_list",
        index: true,
        element: <FileInquiryList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "CAN_VIEW_ALL_FILE_INQUIRY",
        },
      },

      //FILE DETAILS
      {
        id: "File_details",
        path: ID,
        element: <FileInquiry />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "CAN_ASSIGN_FILE_INQUIRY",
        },
      },
    ],
  },

  //TERMINATION LIST
  {
    id: "termination_list",
    path: TERMINATION_LIST,
    element: <TerminationList />,
    redirection: <NoMatch />,
    permissions: {
      auth: ["token"],
    },
  },

  //TERMINATION MODULE
  {
    id: "termination_module",
    path: TERMINATION,
    children: [
      //TERMINATION TABLE
      {
        id: "termination_list",
        index: true,
        element: <Terminations />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },
      //TERMINATION DETAILS
      {
        id: "termination_details",
        path: ID,
        element: <TerminationDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },
      //TERMINATION CREATE
      {
        id: "termination_create",
        path: `${ID}/${CREATE}`,
        element: <TerminationDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },
    ],
  },

  //TRANSFER MODULE
  {
    id: "transfer_module",
    path: TRANSFERS,

    children: [
      //TRANSFER TABLE
      {
        id: "transfer_list",
        index: true,
        element: <Transfers />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "TRANSFER_LIST_PAGE",
        },
      },

      //TRANSFER DETAILS
      {
        id: "transfer_details",
        path: ID,
        element: <TransferDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },
    ],
  },

  //INTERCHANGE TRANSFER MODULE
  {
    id: "interchange_transfer_module",
    path: INTERCHANGE_TRANSFERS,

    children: [
      //TRANSFER TABLE
      {
        id: "interchange_transfer_list",
        index: true,
        element: <InterChangeTransfers />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "TRANSFER_LIST_PAGE",
        },
      },

      //TRANSFER DETAILS
      {
        id: "interchange_transfer_details",
        path: ID,
        element: <InterchangeTransferDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },
    ],
  },

  //PROMOTION CANDIDATE MODULE
  {
    id: "promotion_candidate_module",
    path: PROMOTION_CANDIDATES,
    children: [
      {
        id: "promotion_candidate_list",
        index: true,
        element: <PromotionCandidates />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "PROMOTION_INITIATE",
        },
      },
    ],
  },

  // PROMOTION MODULE
  {
    id: "promotion_module",
    path: PROMOTION,
    children: [
      //   PROMOTION LIST
      {
        id: "promotion_list",
        index: true,
        element: <PromotionList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "PROMOTION_LIST_VIEW_PAGE",
        },
      },
      {
        id: "promotion_details",
        path: ID,
        element: <InitiatePromotion />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "PROMOTION_MODIFY_PAGE",
        },
      },
    ],
  },

  //RETIREMENT MODULE
  {
    id: "retirement_module",
    path: RETIREMENTS,

    children: [
      //RETIREMENT TABLE
      {
        id: "retirement_list",
        index: true,
        element: <RetirementList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "RETIREMENT_LIST_PAGE",
        },
      },

      //RETIREMENT DETAILS
      {
        id: "retirement_details",
        path: ID,
        element: <RetirementDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },

      //RETIREMENT CRETAE
      {
        id: "retirement_create",
        path: `${ID}/${CREATE}`,
        element: <CreateRetirement />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },
    ],
  },

  // RESIGNATION MODULE
  {
    id: "resignation_module",
    path: RESIGNATION,

    children: [
      {
        id: "resignation_list",
        index: true,
        element: <ResignationList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "RESIGNATION_LIST_PAGE",
        },
      },
      {
        id: "resignation_create",
        path: `${ID}/${CREATE}`,
        element: <CreateResignation />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },
      {
        id: "resignation_details",
        path: ID,
        element: <ResignationDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },
    ],
  },

  // RELEASE MODULE
  {
    id: "release_module",
    path: RELEASE,
    children: [
      // RELEASE TABLE
      {
        id: "release_list",
        index: true,
        element: <ReleaseList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "RELEASE_UPDATE",
        },
      },
      //RELEASE DETAILS
      {
        id: "release_details",
        path: ID,
        element: <ReleaseDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "RELEASE_UPDATE",
        },
      },

      //RELEASE CREATE
      {
        id: "release_create",
        path: `${ID}/${CREATE}`,
        element: <ReleaseDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "RELEASE_UPDATE",
        },
      },
    ],
  },

  //ATTENDANCE MODULE
  {
    id: "attentdance_module",
    path: CENTRAL_ATTENDANCE,
    children: [
      {
        id: "attendance_list",
        index: true,
        element: <CentralAttendanceList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "ATTENDANCE_VIEW_PAGE",
        },
      },
    ],
  },

  //LEAVE MODULE
  {
    id: "leave_module",
    path: LEAVE,
    children: [
      {
        id: "leave_list",
        index: true,
        element: <EmployeeLeaveTable />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "LEAVE_VIEW_PAGE",
        },
      },
      {
        id: "leave_settings",
        path: SETTINGS,
        element: <LeaveSettings />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "LEAVE_SETTINGS_UPDATE",
        },
      },
      {
        id: "leave_details_module",
        path: ID,
        children: [
          {
            id: "leave_details",
            path: ID_2,
            element: <LeaveDetails />,
            redirection: <NoMatch />,
            permissions: {
              auth: ["token"],
            },
          },
          {
            id: "leave_update",
            path: UPDATE,
            element: <UpdateLeaveBalance />,
            redirection: <NoMatch />,
            permissions: {
              auth: ["token"],
              access: "LEAVE_UPDATE",
            },
          },
        ],
      },
      {
        id: "1.17.3",
        path: CREATE,
        children: [
          {
            id: "1.17.3.1",
            index: true,
            element: <LeaveApply />,
            redirection: <NoMatch />,
            permissions: {
              auth: ["token"],
            },
          },
        ],
      },
    ],
  },

  //PUNISHMENT MODULE
  {
    id: "punishment_module",
    path: PUNISHMENT,
    children: [
      {
        id: "punishment_list",
        index: true,
        element: <PunishmentHistoryList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "PUNISHMENT_LIST_PAGE",
        },
      },
    ],
  },

  // APR MODULE
  {
    id: "apr_module",
    path: APR,
    children: [
      {
        id: "apr_list",
        index: true,
        element: <Apr />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "APR_LIST_PAGE",
        },
      },
    ],
  },

  //ACR MODULE
  {
    id: "acr_module",
    path: ACR,
    children: [
      {
        id: "acr_list",
        index: true,
        element: <Acr />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "ACR_LIST_PAGE",
        },
      },
    ],
  },

  //DOSSIER MODULE
  {
    id: "dossier_module",
    path: DOSSIER,
    children: [
      {
        id: "dossier_list",
        index: true,
        // element: <DossierList />,
        element: <DossierEmployeeList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "DOSSIER_LIST_PAGE",
        },
      },
      {
        id: "dossier_employee_details",
        path: ID,
        element: <DossierEmployeeDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "DOSSIER_LIST_PAGE",
        },
      },
    ],
  },

  // GPF MODULE
  {
    id: "gpf_module",
    path: PROVIDENT_FUND,
    children: [
      //   GPF LIST
      {
        id: "gpf_list",
        index: true,
        element: <GpfList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "GPF_LIST_PAGE",
        },
      },

      // GPF DETAILS MODULE
      {
        id: "gpf_details_module",
        path: ID,

        children: [
          // GPF INSTALMENT DETAILS
          {
            id: "gpf_instalment_details",
            path: ID_2,
            element: <InstallmentDetails />,
            redirection: <NoMatch />,
            permissions: {
              auth: ["token"],
            },
          },

          //   GPF CREATE
          {
            id: "gpf_create",
            path: CREATE,
            element: <CreateNewLoan />,
            redirection: <NoMatch />,
            permissions: {
              auth: ["token"],
            },
          },
        ],
      },
    ],
  },

  //SETTINGS MODULE
  {
    id: "hrm_settings_module",
    path: HRM_SETTINGS,
    children: [
      {
        id: "hrm_settings",
        index: true,
        element: <HRMSettings />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "CAN_HRM_SETTINGS",
        },
      },
    ],
  },

  //NOTIFICATIONS MODULE
  {
    id: "notifications_list",
    path: NOTIFICATIONS,
    element: <Notifications />,
    redirection: <NoMatch />,
    permissions: {
      auth: ["token"],
    },
  },

  {
    id: "profile",
    path: PROFILE,
    element: <Profile />,
    redirection: <NoMatch />,
    permissions: {
      auth: ["token"],
    },
  },

  //MANPOWER REPORTS
  {
    id: "manpower_reports",
    path: MANPOWER_REPORTS,
    element: <ManpowerReports />,
    redirection: <NoMatch />,
    permissions: {
      auth: ["token"],
    },
  },

  //PROMOTION REPORTS

  {
    id: "promotion_reports",
    path: PROMOTION_REPORTS,
    element: <PromotionReports />,
    redirection: <NoMatch />,
    permissions: {
      auth: ["token"],
    },
  },

  //PRL REPORTS

  {
    id: "prl_reports",
    path: PRL_REPORTS,
    element: <PrlReports />,
    redirection: <NoMatch />,
    permissions: {
      auth: ["token"],
    },
  },

  //PENSION REPORTS

  {
    id: "pension_reports",
    path: PENSION_REPORTS,
    element: <PensionReports />,
    redirection: <NoMatch />,
    permissions: {
      auth: ["token"],
    },
  },

  //RESIGNATION REPORTS

  {
    id: "resignation_reports",
    path: RESIGNATION_REPORTS,
    element: <ResignationReports />,
    redirection: <NoMatch />,
    permissions: {
      auth: ["token"],
    },
  },

  //RETIREMENT REPORTS

  {
    id: "retirement_reports",
    path: RETIREMENT_REPORTS,
    element: <RetirementReports />,
    redirection: <NoMatch />,
    permissions: {
      auth: ["token"],
    },
  },

  //RELEASE REPORTS

  {
    id: "release_reports",
    path: RELEASE_REPORTS,
    element: <ReleaseReports />,
    redirection: <NoMatch />,
    permissions: {
      auth: ["token"],
    },
  },

  //REWARD REPORTS

  {
    id: "reward_reports",
    path: REWARD_REPORTS,
    element: <RewardReports />,
    redirection: <NoMatch />,
    permissions: {
      auth: ["token"],
    },
  },

  //JOB REPORTS

  {
    id: "job_reports",
    path: JOB_REPORTS,
    element: <JobReports />,
    redirection: <NoMatch />,
    permissions: {
      auth: ["token"],
    },
  },

  //EMPLOYEE SUMMARY REPORTS

  {
    id: "manpower_summary_reports",
    path: MANPOWER_SUMMARY_REPORTS,
    element: <ManpowerSummaryReports />,
    redirection: <NoMatch />,
    permissions: {
      auth: ["token"],
    },
  },

  //EMPLOYEE DETAILS REPORTS

  {
    id: "manpower_details_reports",
    path: MANPOWER_DETAILS_REPORTS,
    element: <ManpowerDetailsReports />,
    redirection: <NoMatch />,
    permissions: {
      auth: ["token"],
    },
  },

  //EMPLOYEE RECRUIT REPORTS

  {
    id: "manpower_recruit_reports",
    path: MANPOWER_RECRUIT_REPORTS,
    element: <ManpowerRecruitReports />,
    redirection: <NoMatch />,
    permissions: {
      auth: ["token"],
    },
  },

  //YEARLY REPORTS

  {
    id: "yearly_reports",
    path: YEARLY_REPORTS,
    element: <YearlyReportsPage />,
    redirection: <NoMatch />,
    permissions: {
      auth: ["token"],
    },
  },

  //ACR REPORTS

  {
    id: "acr_reports",
    path: ACR_REPORTS,
    element: <AcrReports />,
    redirection: <NoMatch />,
    permissions: {
      auth: ["token"],
    },
  },
];
